export function hasCanonicalPermission(authUser, permission) {
  return authUser?.permissions?.includes(permission) === true;
}

export function canModerateMetaverse(authUser) {
  return hasCanonicalPermission(authUser, "metaverse:moderate");
}
